import { FC, SVGProps } from 'react';

export const ArrowBackIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.80842 18.0089L4.39906 12.5995C4.06711 12.2675 4.06711 11.7293 4.39906 11.3974L9.80843 5.98804C10.1404 5.65609 10.6786 5.65609 11.0105 5.98804C11.3425 6.31998 11.3425 6.85817 11.0105 7.19012L7.05218 11.1484L19.0001 11.1484C19.4695 11.1484 19.8501 11.529 19.8501 11.9984C19.8501 12.4679 19.4695 12.8484 19.0001 12.8484L7.05218 12.8484L11.0105 16.8068C11.3425 17.1387 11.3425 17.6769 11.0105 18.0089C10.6786 18.3408 10.1404 18.3408 9.80842 18.0089Z"
			fill="currentColor"
		/>
	</svg>
);
